export default function BodyText({ children }: { children: React.ReactNode }) {
  return <p className="my-1 text-sm font-light">{children}</p>
}
